import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { NewTruckComponent } from './new-truck.component';
import { ToastModule } from 'primeng';
import { BBWTMessageService } from '../../services';

const routes: Routes = [{ path: '', component: NewTruckComponent, data: { title: 'New truck' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewTruckRoutingModule {}

@NgModule({
  imports: [
    NewTruckRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [NewTruckComponent],
  providers: [BBWTMessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewTruckModule {}
